import { gql } from '@apollo/client';

export const GET_ENTERPRISE_SUB_ACCOUNTS = gql`
  query GetEnterpriseSubAccounts {
    tm {
      enterpriseSubAccounts {
        tenantId
        name
        fqdn
        dateCreated
        pendingUpdateCount
        lastPushedAt
        mappedEntityCounts {
          entityType
          count
        }
        admins {
          userId
          displayName
          email
          emailVerified
          dateAdded
          access
        }
      }
    }
  }
`;
